export default {
  errors: {
    wrong_brn_format: "Wrong BRN format",
    db_query_failed: "Error database connection",
    db_fetch_failed: "Error reading from the database",
    permission_denied: "You do not have permission to use this system",
    // Spelled to match the key the backend actually sends (WPMLHGV4,
    // WPSubscriberV4), which is missing the d — as is the existing
    // errors.mlhg.access_denie. Do not correct to access_denied until the
    // backend changes the key.
    access_denie: "You do not have permission to access this data",
    eas: {
      required: "Please select an EAS Server",
      not_configured: "EAS Server is not configured",
      enterprise_unbound: "Enterprise has no EAS Server bound",
      capacity_full: "Selected EAS Server is full"
    },
    easmigration: {
      invalid_parameter: "Invalid parameter",
      preflight_blocked: "This corporate cannot be migrated yet",
      enterprise_not_found: "Organization information not found",
      not_main_branch:
        "Only a main branch can be migrated. Please select its parent organization",
      same_eas: "Target EAS Server is the same as the current one",
      in_progress: "A migration for this organization is already in progress",
      target_capacity_full:
        "Target EAS Server does not have room for the whole organization",
      sub_branches_included:
        "Sub-branches of this organization will be migrated as well",
      // Blocking, not a warning: the migration addresses every object on the
      // organization's EAS Server, so a number recorded elsewhere is not found
      // during the move and the job fails part-way through, after other numbers
      // have already been moved.
      number_eas_mismatch:
        "Some numbers are recorded on a different EAS Server than the organization. Correct them before migrating",
      // target_sipserver_missing is defined further down with the other keys
      // the worker writes; the preflight raises the same key, because it is the
      // same condition caught earlier.
      // A hunt group's dummy pilot line is stored in a form this system cannot
      // translate into the name MetaSwitch knows it by.
      dummy_pilot_identity:
        "A hunt group pilot number is stored in an unexpected format and cannot be migrated",
      // A `number` row is stored in a form that cannot be turned into the name
      // MetaSwitch knows the subscriber by — for example a short number whose
      // charge number is missing or malformed.
      number_identity:
        "A number is stored in an unexpected format, so the matching record on MetaSwitch cannot be identified for migration",
      voicemail_destroyed:
        "Voicemail messages stored on the current EAS Server will be deleted permanently",
      // ---- issue #34: start endpoint + background worker ----
      // The operator has to tick the confirmation: voicemail on the source EAS
      // is destroyed by the move and cannot be restored from anywhere.
      voicemail_not_confirmed:
        "Please confirm that voicemail messages will be permanently deleted before starting",
      not_found: "Migration record not found",
      start_failed: "Could not start the migration",
      // ---- issue #41: Read and Migration are two authorised actions ----
      // Migration was pressed on a job that has not completed a read. The read
      // is what establishes whether the corporate can be moved at all, and it
      // destroys nothing, so it has to succeed first.
      read_required:
        "This organization must be read successfully before the migration can be started",
      // A warning, never a refusal: the worker re-checks capacity and probes
      // every object on both EAS Servers immediately before it acts.
      read_stale:
        "This read was taken a while ago and may no longer match the current state. Read again before authorizing the migration",
      // Written into eas_migration.error_log / eas_migration_item.error_log by
      // the worker, as "errors.<key>|<detail>"; the UI shows this text and
      // appends the detail after the pipe.
      source_changed:
        "The organization was moved to a different EAS Server after this migration was queued",
      snapshot_failed: "Could not read the current state from MetaSwitch",
      snapshot_missing: "No snapshot was captured for this object",
      eas_pass_unavailable:
        "The EAS password of this number could not be read, so it cannot be recreated without changing it",
      // The voicemail PIN was not in the snapshot. Substituting a generated or
      // configured one would change a live credential, and the source record is
      // deleted in the next phase, so the original could not be recovered.
      eas_pin_unavailable:
        "The voicemail PIN of this number could not be read, so it cannot be recreated without changing it",
      item_list_invalid: "The migration work list is incomplete",
      bg_create_failed: "Could not create the business group on the target EAS Server",
      source_object_missing: "This object could not be read from the source EAS Server",
      eas_delete_failed: "Could not delete this object from the source EAS Server",
      eas_create_failed: "Could not create this object on the target EAS Server",
      cfs_repoint_failed:
        "Could not update Termination to point at the target EAS Server",
      items_unfinished:
        "Some objects did not finish moving, so the business group was left on the source EAS Server",
      bg_delete_failed: "Could not delete the business group from the source EAS Server",
      bg_delete_not_confirmed:
        "The business group delete was accepted but it is still readable on the source EAS Server after several checks. The job stopped so that one business group name cannot exist on two EAS Servers at once. Check MetaSwitch, then press Retry",
      verify_failed: "Verification after the move failed",
      // The target EAS Server has no orig/term terminating SIP server in
      // config.yml. The migration would then leave every call routed to the
      // source EAS Server while reporting success, so it is refused.
      target_sipserver_missing:
        "The target EAS Server has no SIP Server configured, so call routing cannot be moved to it",
      // The EAS account type of a MAIN_IVR pilot could not be read. Recreating
      // it without one would turn the organization's administrator account
      // into an ordinary line.
      account_type_missing:
        "The account type of this number could not be read, so recreating it would change an administrator account into an ordinary line",
      // Neither EAS Server answered "does not exist", so whether the object is
      // there could not be established. Nothing was sent, so nothing was
      // changed; the operator fixes the cause and runs it again.
      object_state_unknown:
        "The state of this object on the EAS Server could not be established, so the job stopped without changing anything. Check the connection to MetaSwitch and try again",
      // One object on two EAS Servers: an earlier attempt created it on the
      // target and its delete from the source did not land. The job does not
      // guess which copy to remove, because removing the wrong one destroys a
      // working line and MetaSwitch has no undelete.
      object_on_both_eas:
        "This object exists on both the source and the target EAS Server, so which one is serving calls cannot be determined. The job stopped without deleting anything: confirm which server the number registers against, remove the unused copy by hand, then start the migration again",
      // Everything is deleted from the source before anything is created on the
      // target, so by the create pass the source must be empty. A record still
      // standing there means the delete did not land, or the object was
      // re-provisioned while the job ran. Creating over it would put one object
      // on two EAS Servers, which is not allowed.
      object_still_on_source:
        "This object is still on the source EAS Server, and by this point in the migration it should already have been deleted. Nothing was created, because creating it now would leave the same object on two EAS Servers at once. Check the object on the source server, then press “Continue where it stopped” again",
      // The same rule as object_still_on_source, one level up and at the worst
      // moment in the run: the delete pass has already taken every number and
      // the business group off the source, so the corporate is on no EAS Server
      // at all when this lands. The wording has to say what to do AND that the
      // corporate is down right now, not merely report a failure.
      bg_still_on_source:
        "The business group for this corporate is still on the source EAS Server, and by this point in the migration it should already have been deleted. Nothing was created, because one business group name may not stand on two EAS Servers at once. Every number for this corporate has already been removed from the source and stays out of service until the create pass finishes. Confirm which server still holds this business group, remove the stale copy from the source by hand, then press “Continue where it stopped” again",
      // The process running the job was killed mid-flight — a restart, a
      // deployment or an OOM kill — none of which the panic guard can catch.
      // The job is swept to failed so it can be started again instead of
      // sitting in "running" for ever.
      worker_interrupted:
        "The migration was interrupted while it was running, for example by a restart or a deployment, so it was recorded as failed. It can be started again: every object is checked on both EAS Servers before anything is touched",
      // The worker crashed. The job is marked failed rather than left running
      // so that it can be retried.
      worker_panic: "The migration stopped unexpectedly and can be retried",
      // ---- the two extension phases ----
      //
      // delete_extension is the first phase of the delete pass and the first
      // thing in the whole job that writes to MetaSwitch, so a failure here has
      // changed nothing at all. It covers both halves of that phase: a list
      // that could not be read — which is never taken to mean "there was
      // nothing there" — and a clearing update that did not land. Either way
      // the dialling plan is still on the source and every number is still in
      // service, which is what the wording has to say so the operator does not
      // go looking for damage there is none of.
      extension_delete_failed:
        "The extension (intercom code) list could not be cleared from the source business group, so the migration stopped before deleting anything. The corporate is untouched and still in service: fix the cause and start the migration again",
      // create_extension is the last phase of the create pass, and by the time
      // it runs the numbers have already moved. The list it failed to write is
      // in this job's snapshot and nowhere else — not on either EAS Server —
      // so the instruction is to retry this job rather than to read the
      // corporate again, which would only store the post-damage list.
      extension_restore_failed:
        "The extension (intercom code) list could not be written back onto the business group. The numbers themselves did move to the target EAS Server, but the corporate cannot dial its own extensions, and that list now exists only in this job's snapshot — press “Continue where it stopped” until it succeeds"
    },
    // msw: "Error MSW API connection",
    msw_unknown_result: "Error reading from MSW API",
    invalid_param: "The parameter provided is incorrect.",
    // The backend sends both invalid_param and invalid_parameter
    // (WPMLHGV4, WPPackage, WPCorporate), so both keys have to exist.
    invalid_parameter: "The parameter provided is incorrect.",
    // Every v4 xlsx export button uses this key when the file cannot be built.
    // The specific reason arrives in Cause, which the modal already shows
    // separately.
    export_failed:
      "Could not create the export file. Please try again; if it still fails, use the filters to reduce the amount of data being exported.",
    invalid_date: "The parameter date is incorrect.",
    invalid_date_range: "The parameter date range are incorrect.",
    invalid_date_range_over_60: "The selected period is more than 60 days",
    invalid_date_range_over_90: "The selected period is more than 90 days",
    invalid_keyword_number: "The parameter keyword is incorrect.",
    twofa_code: "OTP Error ({0})",
    twofa: {
      S_AUT_00000: "Success",
      B_AUT_00001: "The use name or password is incorrect",
      B_AUT_00002: "Password is incorrect ",
      B_AUT_00402:
        "The system is currently unavailable. Please try again later.",
      B_AUT_00403:
        "The system is currently unavailable. Please try again later.",
      B_AUT_00404:
        "The system is currently unavailable. Please try again later.",
      B_AUT_99999:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00103:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00405:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00503:
        "The system is currently under maintenance. Please try again later.",
      T_AUT_00901:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00902:
        "The system is currently unavailable. Please try again later.",
      T_AUT_99999:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00101:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00102:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00403:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00404:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00406: "The OTP phone number provided is incorrect",
      B_SRV_00410:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61001:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61002:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61003:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61004:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61005:
        "The OTP phone number provided is terminated. Please contact dtac call center 1431",
      B_SRV_61006: "The OTP phone number provided is incorrect",
      B_SRV_61007:
        "System is locked due to reach max attempt. Please try again in 15 minutes",
      B_SRV_61009: "OTP is incorrect. Please try again",
      B_SRV_61010: "OTP has expired. Please try again",
      B_SRV_61011: "OTP is incorrect. Please try again",
      B_SRV_61012: "OTP is not match for 3 times",
      B_SRV_61013: "OTP is incorrect. Please try again",
      B_SRV_99999:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00103:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00405:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00503:
        "The system is currently under maintenance. Please try again later.",
      T_SRV_00901:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00902:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00904:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00905:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00906:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00907:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00908:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00909:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00910:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13001:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13003:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13004:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13005:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13006:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13002:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13000:
        "The system is currently unavailable. Please try again later.",
      T_SRV_99999:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00101:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00102:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00401:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00498:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00502:
        "The system is currently unavailable. Please try again later."
    },
    msw: {
      numberblock_add_failed: "Create Number Block failed",
      number_create_failed: "Could not add this phone number to the system",
      delete_pirot_dummy_failed:
        "Could not delete pilot number from the system ",
      number_delete_failed:
        "Could not delete this phone number from the system",
      voicemail_failed: "Could not process Voicemail"
    },
    // ---- voicemail backup, taken before an EAS migration ----
    //
    // The namespace is `voicemailbackup`, ONE word, because that is how the Go
    // side spells it. Every key below was taken from the backend source rather
    // than agreed in advance:
    //
    //   grep -rhoE '"(errors\.)?voicemailbackup[a-zA-Z0-9_.]*"' controllers/
    //
    // Most are returned as the response `Msg` and resolved by getErrorText().
    // The last four never appear as a Msg at all — the worker writes them into
    // `ErrorLog` in the `key|human detail` form (#24), so the page splits on
    // the pipe and translates the left half. Both halves have to be here or the
    // operator reads a raw key path off the screen.
    voicemailbackup: {
      // --- returned as Msg ---
      invalid_parameter: "The request was missing a valid id",
      not_found: "Backup not found",
      enterprise_not_found: "Corporate not found",
      in_progress:
        "This corporate already has a voicemail backup queued or running",
      start_failed: "Could not start the voicemail backup",
      not_ready: "This backup is not finished yet, so it cannot be downloaded",
      // Restore side. `not_a_backup` guards the one thing the log page must
      // never let through: a restore started from a restore, which has no
      // archive of its own to replay.
      not_a_backup:
        "That job is a restore, not a backup, so there is no archive to restore from",
      extract_failed: "Could not extract the backup archive",
      no_archive_entries:
        "This archive holds no voicemail messages, so there is nothing to restore",
      // MetaSwitch answered SUCCESS but sent no messaging repository at all.
      // NOT an empty mailbox — an empty mailbox still returns its folder.
      no_repository:
        "MetaSwitch answered success but returned no voicemail data for this number, so nothing was archived for it. This is not an empty mailbox. Check that the number exists on the switch before treating this archive as complete",
      restore_failed: "Could not restore the voicemail",
      file_missing:
        "The backup file is no longer on the server. It was cleared or removed by the retention sweep — please take a new backup.",
      storage_failed: "Could not write the backup files on the server",
      compress_failed: "Could not build the backup archive",
      no_numbers: "This corporate has no numbers to back up",
      download_interrupted:
        "The download stopped before the whole file had been sent",
      // --- restore from an archive uploaded back in ---
      // The API runs on two nodes behind nginx with no shared volume: a
      // backup's zip lives on the disk of the node that produced it and is
      // retired by the retention sweep, so the copy the operator downloaded is
      // the one a restore can actually be run from.
      upload_missing_file:
        "The request carried no backup file, or the file it carried was empty. Choose the .zip you downloaded earlier and upload it again.",
      upload_too_large:
        "The uploaded archive is larger than this server accepts, so the restore was not started",
      upload_not_zip:
        "The uploaded file is not a readable .zip. Check that it is the archive downloaded from this page and that the download completed.",
      // Restoring one corporate's voicemail into another corporate's mailboxes
      // is the unrecoverable mistake here. The key is used in two places: as
      // the Msg that refuses a whole upload, and as the per-number Detail prefix
      // restoreOne writes on BOTH restore sources — so the wording has to stay
      // true for one refused row sitting beside rows that say ok. It must not
      // claim that nothing at all was restored.
      upload_wrong_enterprise:
        "A number in this archive does not belong to the corporate being restored, so that number was not restored. Check that the archive really belongs to this corporate.",
      // The file is on the disk of the node that received it and is never
      // copied across, so the fix is another upload — not another restore.
      upload_unreachable:
        "The uploaded archive was received by a different server node, so the node running this job cannot see it and nothing was restored. Please upload the archive again.",
      // --- carried inside ErrorLog as `key|detail` ---
      read_failed: "Could not read voicemail from the EAS Server",
      // ONE key, both halves: errorSummary() in the Go worker hangs off the run
      // struct shared by backup and restore, so this wording must be true of
      // either. The frontend remaps it by Kind (vmErrorKeyForKind) to the two
      // specific strings in the voicemaillog block; this is the fallback for a
      // render with no Kind to go on.
      partial: "Some numbers did not complete",
      worker_interrupted:
        "The server process running this backup stopped before it finished. Please take a new backup.",
      expired: "The backup file was removed by the retention sweep"
    },
    dtac: {
      idcard_validate_fail: "This BRN could not be found",
      subs_query_status_failed:
        "This phone number cannot be found on dtac's system.",
      subs_query_package_failed:
        "No information of this package was found on dtac's system.",
      wci_failed: "Could not create or add this phone number.",
      unknown_result: "Error reading from DTAC API",
      wci_queue: "Creating number in queue"
    },
    user: {
      duplicate: "Duplicate User information",
      duplicate_username: "Duplicate Username information",
      duplicate_email: "Duplicate email information",
      blcok_delete_by_self: "Can't delete data by yourself.",
      fail: "Error update user information",
      email_wrong_format: "Wrong email format",
      enterprise_empty: "Please select Enterprise",
      name_empty: "Please input Name",
      phone_wrong_format: "Wrong phone number"
    },
    corp: {
      wrong_type: "Error invalid corporate type",
      wrong_format: "Wrong Corporate name format",
      duplicate: "Duplicate Corporate information",
      not_exist: "Organization information not found",
      check_number_fail: "The number checking is fail.",
      check_user_fail: "Checking the users in this enterprise failed",
      number_exist: "Error found number in Corporate",
      failed: "Error update Corporate information",
      create_failed: "Error create Corporate information",
      delete_failed: "Error delete Corporate information",
      user_exist: "Error found user in Corporate",
      is_not_main_branch: "Organization is not a main branch"
    },
    mlhg: {
      duplicate: "Duplicate Muti-line Hunting Group information",
      get_dummy_number_fail:
        "Information for dummy number for MLHG is not found",
      not_exist: "Not found this MLHG Information",
      member_not_exist: "Not found this number in this MLHG",
      member_not_in_corp: "Not found this number in this Enterprise",
      get_enterprise_fail: "Not found this Corporate",
      get_mlhg_fail: "Not found this MLHG",
      get_number_fail: "Not found this Number",
      get_pilot_fail: "Not found this Company Number",
      update_number_fail: "Update number in this MLHG failed",
      delete_number_fail: "Delete number in this MLHG failed",
      redeem_dummy_pilot_failed: "Cannot redeem dummy number",
      number_duplicate: "This number is duplicate in this MLHG",
      number_not_in_corp: "This number does not belong to this enterprise",
      invalid_parameter: "Invalid parameter",
      invalid_realnumber: "Wrong real number format",
      access_denie: "Access Denie"
    },
    auth: {
      login_fail: "Login Fail",
      block: "User has been blocked",
      login_success: "Login Success",
      logout_success: "Log out Success",
      unauthoriezed: "No permission",
      reset_invalid_token: "token invalid",
      reset_token_expired: "token reset_token_expired",
      forgot_pass_fail: "forgot password failed",
      reset_pass_fail: "reset password failed",
      username_wrong_format: "Wrong username format",
      pass_wrong_format: "Wrong password format",
      token: "Invalid Token",
      pass: "Invalid password",
      pass_confirm: "Invalid confirm password",
      twofafail: "Request OTP failed",
      request_twofa_fail: "Request OTP failed",
      verify_twofa_fail: "Verify OTP failed",
      maintenance_active: "System under maintenance. Please try again later."
    },
    otp: {
      request_otp_fail: "Request OTP failed",
      verify_otp_fail: "Verify OTP failed"
    },
    package: {
      duplicate_code: "Package Code is Duplicate",
      duplicate_name: "Package Name is Duplicate",
      not_exist: "not found package information",
      delete_lock: "Cannot delete this package Because it is in use",
      get_profile_failed: "The VPBX package could not be found in the system."
    },
    subs: {
      invalid_number: "Invalid Number",
      invalid_pilot_number: "Invalid pilot number format",
      invalid_parameter: "The parameter provided is incorrect.",
      invalid_mapping_number: "Invalid Mapping Number",
      invalid_agent_number: "Wrong agent number format",
      invalid_main_number: "Wrong enterprise number format",
      invalid_charge_number: "Wrong charge number format",
      invalid_alt_number: "Wrong alternative number format",
      invalid_real_number: "Wrong real number format",
      invalid_additional_number: "Wrong additional number format",
      invalid_email: "Invalid E-Mail",
      not_exist: "This Number not exist",
      corp_not_match: "Corporate information not match",
      get_crop_id_failed: "Not found Corporate information or Company Number",
      duplicate: "Duplicate Number",
      get_charge_number_failed:
        "Could not find telephone number information under this company.",
      set_charge_number_failed: " This phone number cannot be changed.",
      get_brn_failed: "Not found this BRN",
      is_mlhg_member: "This number is member of MLHG",
      number_range_delete_fail: "Cannot delete Number Range",
      comp_login_failed: "Error Login to ComPortal",
      subs_status_failed:
        "This Number is not eligible to subscribe this service",
      import_number: "Import number failed",
      reset_pass_fail: "Reset password failed",
      delete_failed: "Delete number failed",
      delete_pilot_number_failed: "Delete pilot number failed",
      delete_number_block_failed: "Delete Number Block failed",
      number_in_mlhg: "This number is pilot of MLHG",
      sync_package_fail: "Sync package failed",
      sync_package_partial: "Sync package completed with errors"
    },
    profile: {
      get_profile_failed: "Get profile failed",
      change_profile_failed: "Change profile failed",
      change_pass_failed: "Change password failed",
      pass_confirm_not_match: "Error confirm password",
      pass_confirm_wrong_format: "Wrong password format.",
      pass_old_wrong: "Wrong old password"
    },
    report: {
      date_over_60: "The selected period is more than 60 days",
      date_over_90: "The selected period is more than 90 days",
      date_over_30:
        "The maximum search period is 90 days. For query mor than 30 days, it will take longer than usual."
    }
  },

  bc_portal: "Web Portal",
  bc_package: "Package",
  bc_voicemail: "Voice Mail",
  bc_report: "Report",
  bc_record: "Record Detail",
  bc_user: "User",
  bc_corporate: "Corporate",
  bc_mlhg: "Hunt Group",
  bc_pilot_number: "Company Number",
  bc_agent_number: "User Number",
  bc_mapping_number: "Mapping Number",
  bc_import_number: "Import User Number",
  bc_capacity: "EAS Capacity",
  bc_change_profile: "Edit Profile",
  bc_change_pass: "Edit Password",

  profile: {
    profile: "Profile",
    name: "Name",
    phone: "Phone",
    email: "E-Mail",
    change_pass: "Change Password",
    pass_old: "Old Password",
    pass_new: "New Password",
    pass_confirm: "Confirm Password",
    change_profile_success: "Change profile succeeded",
    change_pass_success: "Change password succeeded",
    forgot_pass_success:
      "Forgot password succeeded , Please check your email.",
    reset_pass_success: "Reset password succeeded"
  },
  menu: {
    corporate: "Corporate",
    mlhg: "Hunt Group",
    package: "Package",
    pilot_number: "Company Number",
    agent_number: "User Number",
    import_agent_number: "Import User Number",
    number: "Number",
    user: "User",
    voicemail: "Voice Mail",
    cdr: "Record Detail",
    report: "Report",
    nseries: "Voice Conference",
    capacity: "EAS Capacity",
    easmigration: "EAS Migration",
    voicemaillog: "Voicemail Backup",
    corporate_v4: "Corporate (v4)",
    pilot_number_v4: "Company Number (v4)",
    agent_number_v4: "User Number (v4)"
  },
  eas_server: "EAS Server",
  capacity: {
    title: "EAS Capacity",
    server: "EAS Server",
    capacity: "Capacity",
    used: "Used",
    available: "Available",
    corporates: "Corporates",
    pilot_numbers: "Company Numbers",
    agent_numbers: "User Numbers",
    system_total: "System Total Capacity",
    detail: "Detail by EAS Server"
  },
  easmigration: {
    success: "Preflight completed",
    started: "Migration queued",
    // #41: the read is a separate action from the migration and destroys
    // nothing.
    read_started: "Read queued",
    // Shown instead of a number when the target EAS Server has no capacity
    // ceiling, or when its capacity is unknown (server missing from config).
    capacity_unlimited: "Unlimited",
    capacity_unknown: "Unknown",

    // ---- issue #35: the migration page ----
    title: "EAS Migration",
    help:
      "Moves a whole corporate (sub-branches included) to another EAS Server, in three steps: check → read → authorise and migrate. Step 3 deletes everything from the source EAS Server before it creates anything on the target, and the corporate is unreachable for that whole stretch.",
    tab_migration: "Migration",
    tab_logs: "Logs",
    corporate: "Corporate",
    corporate_placeholder: "Select a main corporate",
    target_eas: "Target EAS Server",
    target_eas_placeholder: "Select the target EAS Server",
    current_eas: "Current EAS Server",
    no_eas: "No EAS Server bound",
    none: "None",
    refresh: "Refresh status",

    check_button: "Check before migrating",
    preflight_title: "Preflight result",
    blocking_title: "Blocking problems",
    warnings_title: "Warnings",
    no_warnings: "No warnings",
    preflight_passed: "Preflight passed — the read can be started",
    counts_title: "Work list",
    count_bg: "Business Group",
    count_numbers: "Numbers",
    count_mlhg: "Hunt Group pilot lines",
    count_skipped_alt: "Alternative numbers (not migrated)",
    count_total: "Total work items",
    capacity_title: "Target capacity",
    capacity_capacity: "Capacity",
    capacity_used: "Used",
    capacity_available: "Available",
    capacity_required: "Required",
    sub_branches: "Sub-branches that move with it",

    read_button: "Read",
    read_help:
      "The read pulls and stores everything from MetaSwitch. It deletes nothing and changes nothing.",
    authorise_title: "Authorise the migration",
    authorise_help:
      "The read has finished. The next step deletes and recreates real objects on MetaSwitch, and it is the step that takes the corporate down.",
    read_completed_at: "Read completed at",
    read_age: "Read age",
    voicemail_confirm:
      "I understand that every voicemail message stored on the source EAS Server will be permanently destroyed.",
    start_button: "Start migration",

    progress_read_title: "Reading",
    progress_title: "Migrating EAS Server",
    phase_label: "Phase",
    current_object: "Latest object",
    elapsed: "Elapsed",
    done_label: "Done",
    error_label: "Errors",
    total_label: "Total",

    // ---- the outage window ----
    //
    // The order is now "delete everything, then create everything", not
    // delete-and-recreate one number at a time. Between the two passes not one
    // number of the corporate exists on any EAS Server. These strings exist so
    // an operator cannot read the progress bar as a per-number blip — an
    // operator who thinks it is a blip does not book a maintenance window.
    pass_label: "Pass",
    pass_read: "Read",
    pass_delete: "Delete from source",
    pass_create: "Create on target",
    pass_settle: "Commit and verify",
    pass_read_hint: "deletes nothing, changes nothing",
    // The two hints are the phase order of their pass, and the extension sits
    // at the outer end of each: it is the first thing cleared from the source
    // and the last thing written back to the target. Naming it there is what
    // tells an operator that the dialling plan is part of this run at all.
    pass_delete_hint: "extension → agent → mlhg → bg",
    pass_create_hint: "bg → mlhg → subscriber → extension",
    pass_settle_hint: "the corporate is up again",

    outage_title: "The corporate is unreachable for this whole window",
    outage_bracket: "Unreachable across both passes",
    // The one rule that has to land. Stated before authorising and again while
    // the job runs.
    outage_rule:
      "Every object is deleted from the source EAS Server first, and only then is anything created on the target.",
    outage_window_hint:
      "The outage lasts as long as this whole job, not as long as one number. Book a maintenance window that covers the entire run.",
    outage_pending:
      "Nothing has been deleted yet — the corporate is still up. The outage starts the moment the first delete is sent.",
    outage_open_delete:
      "The corporate is down. This is the delete pass: objects are being removed from the source EAS Server and nothing has been created on the target yet. Service does not return until the create pass has finished.",
    outage_open_create:
      "The corporate is still down. The source is clear and objects are being created on the target; numbers come back as their creates land, and the corporate is whole only when the last one does.",
    outage_open_failed:
      "This job stopped inside the outage window. The corporate is down right now and will not recover on its own — press “Continue where it stopped” until it succeeds.",
    outage_closed: "Every object has been created. The corporate is up again.",

    // One per EasMigrationPhase*V4 constant in
    // controllers/WPEasMigrationStoreV4.go.
    phase_preflight: "Preflight",
    phase_snapshot: "Snapshot",
    phase_plan: "Final readiness check (nothing deleted yet)",
    // The extension list is a business-group repository (intercom code ranges),
    // so it goes when the business group goes. It is therefore cleared before
    // anything else is deleted and written back after everything else is
    // created — the outermost object of the run in both directions.
    phase_delete_extension:
      "Clear the extension (intercom code) list on source",
    phase_delete_subs: "Delete numbers from source",
    phase_delete_mlhg: "Delete Hunt Group pilot lines from source",
    phase_delete_bg: "Delete source Business Group",
    phase_create_bg: "Create target Business Group",
    phase_create_mlhg: "Create Hunt Group pilot lines on target",
    phase_create_subs: "Create numbers on target and update Termination",
    phase_create_extension:
      "Write the extension (intercom code) list back on target",
    phase_commit: "Commit to database",
    phase_verify: "Verify",
    // The retired interleaved phase. No worker writes it any more, but rows
    // written by an older build still carry it and still have to render.
    phase_numbers: "Migrate numbers one at a time (old order — retired)",
    // The retired check-and-restore extension step, which ran once at the end
    // and wrote only if something was already missing. It is not either of the
    // two phases above, so it keeps a name that claims nothing about what a
    // historical job did.
    phase_retired: "Retired step",
    phase_unknown: "Unknown phase",

    status_queued: "Queued",
    status_running: "Running",
    status_success: "Success",
    status_failed: "Failed",
    status_read_ok: "Read complete",
    status_unknown: "Unknown",

    item_pending: "Pending",
    item_done: "Done",
    item_not_attempted: "Not attempted",
    item_failed: "Failed",
    item_skipped: "Skipped",
    item_unknown: "Unknown",

    job_title: "Current migration",
    job_id: "Migration ID",
    source: "Source",
    target: "Target",
    job_status: "Status",
    attempt: "Attempt",
    result_title: "Per-item result",
    col_seq: "Seq",
    col_kind: "Kind",
    col_object: "MetaSwitch object",
    col_delete: "Delete",
    col_create: "Create",
    col_repoint: "Termination",
    col_verify: "Verify",
    col_result_code: "Result code",
    col_error: "Error",
    col_updated: "Updated",
    no_items: "No items yet",

    // What the read stored for one item. Fetched only when a row is opened.
    col_snapshot: "Read data",
    view_snapshot: "View read data",
    snapshot_title: "What the read pulled",
    snapshot_empty: "The read stored nothing for this item.",
    snapshot_masked:
      "PIN and password values are masked. The unmasked values are kept only in the database, where the recreate reads them.",
    snapshot_truncated:
      "Showing {shown} of {total} stored repositories for this item.",
    snapshot_seq: "seq",
    snapshot_half_cfs: "CFS",
    snapshot_half_eas: "EAS",
    snapshot_half_unknown: "Unknown server",

    retry_button: "Continue where it stopped",
    retry_title: "Continue this migration?",
    // Must not read as "start over": the worker re-probes every item against
    // both EAS servers and only redoes the parts that are not finished.
    retry_text:
      "Every item is re-checked against MetaSwitch first, then only the unfinished work is redone. This does not start over. {count} item(s) still have work left.",
    // Used when the page does not hold the full item list and therefore cannot
    // count what is left. Stating a number that is too low is worse than
    // stating none at all on a destructive confirmation.
    retry_text_unknown:
      "Every item is re-checked against MetaSwitch first, then only the unfinished work is redone. This does not start over. This job has more items than this page can list, so the number still outstanding cannot be shown.",
    retry_yes: "Yes, continue",
    // A job that failed during its read was never authorised, so /retry refuses
    // it with errors.easmigration.read_required. Reading again is the recovery.
    reread_required:
      "This job failed while reading, so nothing was migrated and there is no unfinished work to continue. Press Read again to start over.",

    logs_title: "Migration logs",
    log_help:
      "The timeline of the selected migration, including the SOAP sent and received.",
    log_level: "Level",
    log_level_all: "All levels",
    log_attempt: "Attempt",
    log_attempt_all: "All attempts",
    // Offered from the phases and functions this job actually wrote, so the
    // lists differ between a job that finished and a job that stopped early.
    log_phase: "Step",
    log_phase_all: "All steps",
    log_func: "Function",
    log_func_all: "All functions",
    search: "Search",
    col_time: "Time",
    col_phase: "Phase",
    col_level: "Level",
    col_func: "Function",
    col_message: "Message",
    col_soap: "SOAP",
    view_soap: "View SOAP",
    soap_title: "SOAP Envelope",
    copy_soap: "Copy SOAP",
    no_logs: "No log entries",
    select_job_first: "Select or start a migration first",

    // ---- voicemail backup, taken before an EAS migration ----
    //
    // The migration permanently deletes every stored message on the source EAS
    // Server, so this button has to come before the migration steps: once the
    // delete pass has run there is nothing left to copy.
    vm_button: "Back up voicemail",
    vm_help:
      "Back up the voicemail of every number in the selected corporate into a ZIP file on the server before starting an EAS migration — the messages on the source EAS Server are permanently deleted by it. The archive is kept: download it, or restore from it, later from the Voicemail Backup Log page.",
    vm_title: "Voicemail backup",
    // The three steps in the progress strip. All three are the backend's own
    // phases now: this page no longer does work of its own after the ZIP
    // exists, because the archive is kept rather than downloaded and deleted.
    vm_step_read: "Read",
    vm_step_read_hint: "number by number",
    vm_step_compress: "Compress",
    vm_step_compress_hint: "build the ZIP",
    vm_step_ready: "Ready",
    vm_step_ready_hint: "the ZIP is on the server",
    vm_progress_label: "Progress",
    vm_current_number: "Reading number",
    // The worker has not reported a number yet — not the same as stuck.
    vm_current_none: "preparing…",
    vm_messages: "Messages",
    vm_errors: "Errors",
    vm_elapsed: "Elapsed",
    vm_size: "Size",
    vm_ready_text:
      "Backup complete. Every number was read, and the ZIP file is on the server.",
    // Finished, but not every mailbox made it into the zip. Said plainly,
    // because an operator who reads "complete" and starts the migration loses
    // exactly the messages this line is about.
    vm_partial:
      "The backup finished, but some numbers were not archived — either they could not be read, or the switch answered success and returned no voicemail data for them. The ZIP file is therefore incomplete. Open the Voicemail Backup Log and use View log to see which numbers, before starting the EAS migration.",
    vm_error_title: "Voicemail backup failed",
    vm_error_log_title: "Detail reported by the worker",
    vm_failed: "Voicemail backup failed",
    vm_download_failed: "Could not download the backup file",
    // The button is offered from Downloadable, never from the phase: a job can
    // sit at `ready` with its archive already reaped by the retention sweep.
    vm_download_button: "Download ZIP",
    // Phase "ready" but Downloadable false: the row still says ready and the
    // archive is not on the disk any more.
    vm_file_missing:
      "The backup finished, but its file is no longer on the server — it was removed by the retention sweep or lost with the process that built it. Please take a new backup before starting the EAS migration.",
    // StatusName failed while Phase never said so: the worker process was
    // stopped mid-run.
    vm_worker_stopped:
      "The server process running this backup stopped before it finished, so the archive does not cover every number. Please take a new backup before starting the EAS migration.",
    // The server answered ok without a JobId, so there is nothing to poll or
    // download.
    vm_no_job_id:
      "The server did not return a job id, so the backup cannot be tracked or downloaded. Please try again.",
    failed: "Request failed"
  },

  // The three NON-error Msg values the voicemail backup endpoints answer with.
  // The page does not render them today — it drives the flow from Phase and
  // shows its own wording — but they reach getErrorText() the moment anyone
  // surfaces a success Msg, and an unresolved key renders as its own path.
  // Kept in parity with th.js by scripts/check-i18n-keys.js.
  // ---- the Voicemail Backup Log page (VoicemailBackupLog.vue) ----
  //
  // A namespace of its own, deliberately NOT the `voicemailbackup` block below.
  // That block holds the keys the BACKEND spells and returns as Msg; this one
  // holds the page's own wording. Kept together, a new label on this page could
  // collide with a key Go emits, and the page would quietly start rendering the
  // backend's sentence instead of its own.
  voicemaillog: {
    title: "Voicemail Backup and Restore",
    list_title: "Backup and restore jobs",
    help:
      "Every voicemail backup and restore on this system. Download an archive, see the per-number result, or restore a backup's messages onto the switch after an EAS migration.",
    search: "Search",
    filter_kind: "Job type",
    kind_all: "All",
    kind_backup: "Backup",
    kind_restore: "Restore",
    filter_corporate: "Corporate",
    corporate_all: "All corporates",

    col_kind: "Type",
    col_corporate: "Corporate",
    col_created: "Started",
    col_by: "Run by",
    col_numbers: "Numbers",
    col_counts: "Messages / errors",
    col_status: "Status",
    col_size: "File size",
    col_actions: "Actions",
    messages_label: "Messages",
    errors_label: "Errors",
    no_file: "No file",
    no_rows: "No jobs found",

    btn_download: "Download",
    btn_log: "View log",
    btn_restore: "Restore",

    // ---- upload an archive to restore from ----
    //
    // The one restore that does not hang off a row. The API runs on two nodes
    // behind nginx with no shared volume, so the server's copy of an archive is
    // temporary: it is on the disk of whichever node produced it, and the
    // keep-newest-N sweep retires it. The file the operator downloaded is the
    // copy that is still there weeks later, and this is the way back in for it.
    upload_button: "Upload a backup to restore",
    upload_hint:
      "The server keeps its own copy of an archive only temporarily, so a .zip you downloaded is restored by uploading it back here.",
    upload_title: "Restore from an uploaded backup",
    upload_corporate: "The corporate this archive belongs to",
    upload_corporate_placeholder: "-- choose a corporate --",
    upload_file: "Backup archive (.zip)",
    upload_file_placeholder: "Choose the .zip you downloaded",
    // Said again here because this entry point shows no per-row confirmation:
    // the file came out of a Downloads folder, so there is no corporate name
    // and no backup date on screen to check it against.
    upload_explain:
      "The messages in this archive will be merged back into the mailboxes of the numbers named inside it. Nothing is overwritten: messages that arrived after the backup are kept, and anything already there is not duplicated. The corporate chosen here must be the one the archive was taken from — the server checks this and refuses the upload if it does not match.",
    upload_confirm: "Upload and restore",
    upload_uploading:
      "Uploading {percent}% — please leave this window open until it finishes",
    upload_failed: "Could not upload the archive to restore from",

    // All seven Phase values: the first three belong to a backup, the next
    // three to a restore, and error to either.
    phase_read: "Reading messages",
    phase_compress: "Compressing",
    phase_ready: "Ready to download",
    phase_extract: "Extracting",
    phase_restore: "Merging",
    phase_done: "Finished",
    phase_error: "Failed",

    status_queued: "Queued",
    status_running: "Running",
    status_ready: "Ready",
    status_failed: "Failed",

    action_read: "Read",
    action_restore: "Merge",
    // Three results, not two. `no_data` is "the switch answered, but nothing
    // was archived for this number". It must not read as success and must not
    // read as a failure to reach the switch.
    result_ok: "Read",
    result_error: "Error",
    result_no_data: "No data",

    log_title: "Per-number result",
    log_col_seq: "#",
    log_col_number: "Number",
    log_col_action: "Action",
    log_col_result: "Result",
    log_col_messages: "Messages",
    log_col_detail: "Detail",
    log_col_time: "Time",
    log_none: "This job has no per-number rows yet",
    // The operator arrives here from the amber "the archive is incomplete"
    // warning, so the three states have to be spelled out rather than left to
    // a badge colour.
    log_legend:
      "Read = the messages were read off the switch, including a genuinely empty mailbox. No data = the switch answered success but returned no voicemail data for the number at all, so nothing was archived for it. Error = the switch could not be reached, or refused the request. Both No data and Error count towards this job's error total.",
    log_no_data_note:
      "Some numbers came back as success but with no voicemail data at all, so nothing was archived for them. This is not an empty mailbox. Check that these numbers exist on the switch, and on the right EAS Server, before starting an EAS migration — the migration permanently deletes the messages on the source.",
    log_count_read: "Read",
    log_count_incomplete: "Incomplete",

    // The two honest halves of errors.voicemailbackup.partial. A partial backup
    // is a failure to READ; a partial restore is a failure to WRITE, and merge
    // gives it causes a read never had — a number the switch refused, a message
    // with no recording to send, a merge that added nothing.
    partial_backup:
      "Some numbers were not archived, so the backup is incomplete",
    partial_restore:
      "Some numbers were not merged back — the switch refused the number, the message carried no recording, or nothing was added for it",
    log_failed: "Could not read the per-number log",
    list_failed: "Could not read the list of backup and restore jobs",
    download_failed: "Could not download the backup file",

    // A restore MERGES into the live mailboxes: messages that arrived since the
    // backup are kept, archived messages already present are not duplicated,
    // and running it twice changes nothing. Saying otherwise would frighten an
    // operator off restoring into a live mailbox, which is the exact case merge
    // was built for. It still names the corporate and the backup date, because
    // the rows on this page differ only by those two things.
    restore_confirm_title: "Restore this voicemail backup?",
    restore_confirm_text:
      "The messages in the backup of {corporate} (taken {created}) will be merged back into those numbers' mailboxes. Messages that arrived after the backup are kept, and anything already there is not duplicated — only what is missing is added, so running this twice changes nothing. Check the corporate name before confirming.",
    restore_confirm_yes: "Yes, restore",

    restore_title: "Voicemail restore",
    restore_step_extract: "Extract",
    restore_step_extract_hint: "read the archive",
    restore_step_restore: "Merge",
    restore_step_restore_hint: "number by number",
    restore_step_done: "Finished",
    restore_step_done_hint: "messages are back in the mailboxes",
    restore_progress_label: "Progress",
    restore_current_number: "Merging number",
    restore_current_none: "preparing...",
    restore_elapsed: "Elapsed",
    restore_done_text:
      "Restore complete. Every number in the archive was merged back into its mailbox, keeping the messages that were already there.",
    // Finished but incomplete. Said plainly, so nobody reads "restore
    // complete" and believes this corporate is whole again.
    restore_partial:
      "The restore finished, but some numbers were not merged back — the switch may have refused the number, or a message carried no recording. Nothing that was already in those mailboxes was lost, but this archive was not fully restored. Open the per-number log to see which numbers, then run the restore again if you wish: repeating it will not duplicate anything.",
    restore_error_title: "Voicemail restore failed",
    restore_error_log_title: "Detail reported by the worker",
    restore_failed: "Voicemail restore failed",
    restore_no_job_id:
      "The server did not return a job id, so the restore cannot be tracked. Check the list for the job before trying again.",
    restore_worker_stopped:
      "The server process running this restore stopped before it finished. Open the per-number log to see how far it got. The numbers it had already merged are unaffected, and running the restore again will only add what is still missing.",
    restore_see_log:
      "Use View log on this restore's row to see the result for each number."
  },

  voicemailbackup: {
    started: "The voicemail backup has been queued",
    restore_started: "The voicemail restore has been queued",
    success: "OK"
  },
  export: {
    button: "Export",
    processing: "Processing",
    processing_text: "Generating Excel file, please wait…",
    failed: "Export failed",
    error_title: "Export error"
  },
  "errors.eventlog.range_over_one_day": "Date range cannot exceed 2 days",
  // The errors.db.* keys have to be written flat (whole key quoted) at the top
  // level, because the backend sends both "errors.db.query" and
  // "errors.db.query.failed". Nested, errors.db.query would have to be a string
  // and an object at the same time, which is impossible. vue-i18n tries the
  // dotted path first, finds no errors.db, and then falls back to a flat
  // top-level key (see VueI18n.prototype._interpolate).
  "errors.db.query": "Error database connection",
  "errors.db.query.failed": "Error database connection",
  logs: {
    title: "Event Logs",
    range: "Range",
    range_last_1h: "Last 1 hour",
    range_last_2h: "Last 2 hours",
    range_last_12h: "Last 12 hours",
    range_last_24h: "Last 24 hours",
    range_custom: "Custom",
    start_date: "Start Date / Time",
    end_date: "End Date / Time",
    session_id: "Session ID",
    session_id_placeholder: "Filter by session id (partial match)",
    search: "Search",
    user: "User",
    user_id: "User",
    route: "Route",
    start_at: "Started",
    events: "Events",
    errors: "Errors",
    actions: "Actions",
    view: "View",
    timeline: "Session Timeline",
    no_events: "No events for this session",
    copy_detail: "Copy detail",
    view_xml: "View XML",
    xml_title: "SOAP XML",
    copy_xml: "Copy XML"
  },
  bc_logs: "Event Logs",
  bc_migration: "Migration Tools",
  bc_easmigration: "EAS Migration",
  bc_voicemaillog: "Voicemail Backup Log",
  migration: {
    title: "Migration Tools",
    clear_title: "Clear Number Data",
    clear_help: "Looks up the subscriber on MetaSwitch and clears every trace (Subscriber + NumberBlock + WCI). Only the phone number is needed — Business Group, CFS, and EAS server are read from the subscriber record.",
    number: "Phone Number",
    clear_button: "Clear",
    confirm_title: "Confirm clear?",
    confirm_text: "This will permanently remove {number} from WCI + MetaSwitch.",
    confirm_yes: "Yes, clear",
    running: "Running",
    running_text: "Calling WCI and MetaSwitch...",
    result: "Result",
    overall_ok: "all ok",
    overall_partial: "partial",
    col_step: "Step",
    col_status: "Status",
    col_code: "Code",
    col_detail: "Detail",
    failed: "Clear failed"
  },
  maintenance: {
    title: "System under maintenance",
    description:
      "We're sorry for the inconvenience. The system will be back online soon."
  },
  auth: {
    signin: "Sign In",
    signout: "Logout",
    username: "E-Mail or Number",
    email: "E-Mail",
    pass: "Password",
    forgetpass: "Forgot Password",
    resetpass: "Reset Password",
    confirm_reset_pass: "Confirm reset password for ",
    twofa: "Confirm OTP",
    twofa_send_to: "Your OTP code has been sent via sms to {0}",
    otp_ref_code: "(OTP Reference Code: {0})",
    refcode: "Ref Code",
    otpcode: "OTP Code",
    requestotp: "Request OTP",
    requestnewotp: "Request New OTP in {0} seconds"
  },
  corp: {
    name: "Corporate",
    brn: "BRN",
    code: "Code",
    create: "Create Corporate",
    create_success: "Successfully created the corporate",
    create_fail: "Failed to create corporate"
  },
  package: {
    name: "Package",
    code: "Package Code",
    create: "Create Package",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "Successfully created the package",
    create_fail: "Failed to create package"
  },
  number: {
    type: "Number Type",
    add: "Add Number",
    pilot: "Company Number",
    agent: "User Number",
    charge: "Charge Number",
    syncpackage: "Sync Package for all",
    create_success: "Successfully created the Number",
    agent_create: "Create User Number",
    pilot_create: "Create Company Number",
    pilot_create_success: "Successfully created the Company Number",
    pilot_create_fail: "Failed to create the Company Number",
    agent_create_success: "Successfully created the User Number",
    agent_create_fail: "Failed to create the User Number",
    bgadmin_login_fail: "Login BG Admin Failed",
    comportal_login_fail: "Login Comm Portal Failed",
    sync_package_success: "Sync package succeeded",
    alternative: "Alternative Number",
    main_ivr: "Main IVR",
    real: "Real Number",
    additional: "Additional Number",
    mapping: "Mapping Number"
  },
  voicemail: {
    name: "Voice Mail",
    to: "to",
    from: "from",
    date: "date",
    corp: "Corporate"
  },
  report: {
    chart_answer: "Answered (call)",
    chart_abandon: "Abandon (call)",
    chart_talk_time_avg: "AVG Talk Time (min)",
    chart_talk_time: "Talktime Per Day (min)",
    unit_call: " (calls)",
    unit_min: " (minute)",

    inbound_answer: "Answered Inbound",
    inbound_abandon: "Abandon Inbound",
    inbound_talk_time_avg: "AVG Talk Time",
    inbound_talk_time: "Talktime Per Day",

    outbound_answer: "Answered Outgoing Call",
    outbound_abandon: "Abandon Outbound",
    outbound_talk_time_avg: "AVG Talk Time",
    outbound_talk_time: "Talktime Per Day",

    internal_answer: "Answered Internal",
    internal_abandon: "Abandon Internal",
    internal_talk_time_avg: "AVG Talk Time",
    internal_talk_time: "Talktime Per Day",
    menu: "Record Detail",
    charging_group: "Charging Group",
    export: "Export",
    enterprise_number: "Enterprise Number",
    number: "Number",
    enterprise: "Enterprise Name",
    enterprise_sub: "Enterprise Branch",
    type: "Type",
    cdr_report: "CDR report ",
    dashboard_report: "Dashboard Report ",
    performance_report_type: "Performance Report Type",
    performance_by_number: "Performance by number / agent",
    performance_by_group: "Performance by group",
    date: "date",
    start: "Start date",
    end: "End date",
    search: "Search ",
    call_type: "call type",
    outbound: "outbound",
    inbound: "inbound",
    internal: "internal",
    voicemail: "voicemail",
    all: "all",
    call_status: "call status",
    status_answered: "answered",
    status_no_answer: "no answer",
    corporate: "corporate",
    call_dates: "call dates",
    call_origination: "call origination",
    display_number: "display number",
    call_termination: "call termination",
    start_time: "start time",
    ringing: "ringing (second)",
    answered_time: "answered time",
    terminated_time: "terminated time",
    terminated_reason: "terminated reason",
    reason_change: "reason change",
    final_number: "Transferred destination number",
    duration: "duration (second)",
    total_call: "All transaction logs",
    answered: "All voice calls (outgoing and incoming)",
    unanswered:
      "ALL MISSED INCOMING CALLS, MISSED OUTGOING CALLS AND MISSED CALLS TO HUNTING GROUP",
    longest_waiting_time:
      "Longest call waiting time (including outgoing and incoming calls)",
    avg_waiting_time: "AVERAGE STAFF’S CALL WAITING TIME (SECOND)",
    avg_talk_time: "Avg talk time (second)",
    call_volume: "Transaction logs per day",
    number_of_calls: "number of calls (calls)",
    talk_time:
      "All voice call duration including dtac OneCall connection duration",
    idle_time: "idle time",
    speed_of_answer: "speed of answer (second)",
    status: "Status",
    date_warning:
      "The maximum search period is 90 days. For query more than 30 days, it will take longer than usual.",
    data_start:
      "The system will display information from February 25, 2022 onwards.",
    call_voicemail: "Voicemail (calls)",
    no_number: "No Caller ID"
  },
  user: {
    create: "Create User",
    name: "Name",
    username: "Username",
    type: "Type",
    phone: "Phone",
    role: "Role",
    create_success: "Create User succeeded",
    create_fail: "Create User failed"
  },
  mlhg: {
    name: "Hunt Group",
    failed: "Hunt Group failed",
    success: "Hunt Group succeeded",
    pilot_number: "Pilot Number",
    pilot_number_type: "Pilot Number Type",
    pilot_number_dummy: "Dummy Number",
    pilot_number_real: "Real Number"
  },

  corporate_main: "Main Corporate",
  group_name: "Group Name",
  email: "E-Mail",
  email_optional: "E-Mail (Optional)",
  created: "Created",
  save: "Save",
  back: "Back",
  new: "New",
  status: "Status",
  download: "Download",
  downloadall: "Download All",
  search: "Search",
  welcome: "Welcome",
  myprofile: "Profile",
  changepass: "Change Password",
  page_notfound: "Sorry Page not found.",
  page_notfound_desc: "Plase check URL again.",
  actions: "Menu",
  data: "Data ",
  to: "To",
  of: "Of",
  row_select: "rows selected",
  yes: "Yes",
  no: "No",
  ok: "Ok",
  cancel: "Cancel",
  upload_file: "Upload File",
  upload: "Upload",
  upload_number_success: "Upload number success.",
  bg_admin: "Admin Setting",
  comportal: "Agent Setting",
  add: "Add",
  import: "Import",
  clear: "Clear",
  close: "Close",
  please_select: "Please select..",
  create: "Create",
  confirm: "Confirm",
  create_success: "Create success",
  delete_confirm: "Confirm delete",
  delete_confirm_text: "Please confirm delete ",
  delete_confirm_question: "Do you want to delete this information ? ",
  delete_success: "Delete succeeded",
  delete_fail: "Delete Failed",
  edit_success: "Editing succeeded",
  edit_fail: "Editing failed",
  edit: "Edit",
  delete: "Delete",
  import_inprogress: "Import processing.",
  processing: "Processing"
};
